import React, {useEffect, useState} from 'react';
import Logo from './Logo'
import Breadcrumb from './Breadcrumb'
import Notifications from './Notifications'
import Account from './Account'
import MobileMenu from './MobileMenu'
import MainMenu from './MainMenu'
import Search from './Search'
import DarkMode from "../DarkMode";
import {axiosInstance, useAuth} from "store/auth";
import {applyFestivalBranding, fallbackFestival, normalizeFestival} from "lib/festivalConfig";
import FestivalSwitcher from "./FestivalSwitcher";

export default function Navbar() {
   const {sidebar} = useAuth();
   const [festival, setFestival] = useState(fallbackFestival);
   const [festivals, setFestivals] = useState([]);
   const [festivalSwitching, setFestivalSwitching] = useState(false);
   const [festivalError, setFestivalError] = useState('');

   useEffect(() => {
      axiosInstance.get('/festival').then(({data}) => {
         const current = normalizeFestival(data.data);
         setFestival(current);
         applyFestivalBranding(current);
      }).catch(() => undefined);
      axiosInstance.get('/panel/festivals').then(({data}) => {
         setFestivals(data.data.festivals || []);
      }).catch(() => undefined);

      const handleFestivalChange = (event) => {
         const current = normalizeFestival(event.detail);
         setFestival(current);
         setFestivals((items) => items.map((item) => ({...item, is_active: item.slug === current.slug})));
         applyFestivalBranding(current);
      };
      window.addEventListener('vfilms:festival-changed', handleFestivalChange);
      return () => window.removeEventListener('vfilms:festival-changed', handleFestivalChange);
   }, []);

   const activateFestival = async (slug) => {
      if (slug === festival.slug) return;
      setFestivalSwitching(true);
      setFestivalError('');
      try {
         await axiosInstance.put(`/panel/festivals/${slug}/activate`);
         window.location.reload();
      } catch (error) {
         setFestivalError(error?.response?.data?.error || error?.response?.data?.message || 'تغییر جشنواره فعال انجام نشد.');
         setFestivalSwitching(false);
      }
   };

   return (
      <>
      <MobileMenu
         festival={festival}
         festivals={festivals}
         busy={festivalSwitching}
         error={festivalError}
         onFestivalChange={activateFestival}
      />
         <div className="border-b border-theme-29 -mt-10 md:-mt-5 -mx-3 sm:-mx-8 px-3 sm:px-8 pt-3 md:pt-0 mb-5">
            <div className="top-bar-boxed flex items-center">
               <Logo festival={festival}/>
               <FestivalSwitcher
                  activeFestival={festival}
                  festivals={festivals}
                  busy={festivalSwitching}
                  error={festivalError}
                  onChange={activateFestival}
               />
               <Breadcrumb/>
               <DarkMode/>
               <Search/>
               <Notifications/>
               <Account/>
            </div>
         </div>
         {!sidebar && <MainMenu/>}
      </>)
}
